module.exports = jQuery.noConflict();


//////////////////
// WEBPACK FOOTER
// external "jQuery.noConflict()"
// module id = 6
// module chunks = 8